export function interopDefault<T>(m: T): T {
  return (m as any).default || m;
}
